import { Title } from '@winnin/winnin_ui.components.title'

import { ReactComponent as EmptyImage } from 'assets/images/svg/topics/empty-niche.svg'
import { ChartPrintProvider } from 'contexts/ChartPrintContext'
import { useTranslate } from 'lib/tolgee'
import { CreateNicheDashboardModal, NicheCardList, NicheChartSelector, NicheDescription } from 'modules/niche'
import { translations as nicheTranslations } from 'modules/niche/common/niche.i18n'
import { TOLGEE_GLOBALS } from 'utils'

import NicheChartsTabEmpty from './niche-charts-tab.empty'
import { translations } from './niche-charts-tab.i18n'
import type { INicheChartsTab } from './niche-charts-tab.types'
import { ContextList } from '../context-list'
import './niche-charts-tab.styles.scss'

export const NicheChartsTabView = ({
  feature,
  activeContext,
  contexts,
  handleSelectContext,
  nicheList,
  error,
  loading,
  refetch,
  isEmpty,
  territoryIds,
  territoryContentFilters,
  isChartReady,
  nichesWithPerformance,
  chartDataLoading,
  chartDataError,
  chartDataRefetch,
  handleModal,
  isModalOpen,
  territoryTitle,
  chartUniverseData,
  handleOpenDashboardModal,
  entityId,
  isLoadingContext,
  hideCreateContext,
  handleCreateContext,
  hasReachedLimit,
  handleReset,
  shouldDisplayResetButton,
  shouldDisplayContextDescription,
  contextDescription,
  isContextEmpty,
  hasReachedSelectedNicheLimit,
  isNichePending,
  defaultUploadDate,
}: INicheChartsTab) => {
  const t = useTranslate()
  if (isContextEmpty) {
    return (
      <div className="NicheChartsTab-empty">
        <EmptyImage height="258px" width="274px" />
        <p className="NicheChartsTab-emptyContextsText">{t(translations.emptyContexts)}</p>
      </div>
    )
  }
  return (
    <div className="NicheChartsTab">
      <div className="NicheChartsTab-contextList">
        <ContextList
          activeContext={activeContext}
          contexts={contexts}
          handleActiveContext={handleSelectContext}
          isLoadingContext={isLoadingContext}
          hideCreateContext={hideCreateContext}
          handleCreateContext={handleCreateContext}
          hasReachedLimit={hasReachedLimit}
        />
      </div>
      {shouldDisplayContextDescription && (
        <div className="NicheChartsTab-contextDescription">
          <NicheDescription descriptionText={contextDescription} isLoading={!contextDescription} />
        </div>
      )}
      {isEmpty ? (
        <NicheChartsTabEmpty contextId={activeContext.id} />
      ) : (
        <div className="NicheChartsTab-nicheContent">
          <div className="NicheChartsTab-nicheList">
            <div className="NicheChartsTab-nicheListTitleRow">
              <Title tag="h3">{t(nicheTranslations.compareThemes)}</Title>
              {shouldDisplayResetButton && (
                <button className="NicheChartsTab-resetButton" onClick={handleReset}>
                  {t(TOLGEE_GLOBALS.reset)}
                </button>
              )}
            </div>
            <NicheCardList
              hasReachedSelectedNicheLimit={hasReachedSelectedNicheLimit}
              niches={nicheList}
              error={error}
              loading={loading}
              refetch={refetch}
              isNichePending={isNichePending}
              feature={feature}
            />
          </div>
          <div className="NicheChartsTab-charts">
            <ChartPrintProvider>
              <NicheChartSelector
                nichesWithPerformance={nichesWithPerformance}
                territoryIds={territoryIds}
                territoryContentFilters={territoryContentFilters}
                chartDataUniverse={chartUniverseData}
                handleOpenDashboardModal={handleOpenDashboardModal}
                isChartReady={isChartReady}
                chartDataLoading={chartDataLoading}
                chartDataError={chartDataError}
                chartDataRefetch={chartDataRefetch}
                defaultUploadDate={defaultUploadDate}
              />
            </ChartPrintProvider>
          </div>
        </div>
      )}
      {isModalOpen && (
        <CreateNicheDashboardModal
          contextName={activeContext.name}
          handleCloseModal={handleModal}
          isOpen={isModalOpen}
          nicheList={nicheList}
          territoryName={territoryTitle}
          entityId={entityId}
        />
      )}
    </div>
  )
}
